import { SegmentedControl, UnderlineNav } from '@primer/react';
import { ListOrderedIcon, TrackedByClosedCompletedIcon } from '@primer/octicons-react';
import React from 'react';
interface IClbNgoaiKhoaNavigationProps {
    selectedTab: string,
    onSelectedChanged: (tab: string) => void
}
const MeetingNavigation = (props: IClbNgoaiKhoaNavigationProps) => {
    return (
            <UnderlineNav aria-label="Repository" sx={{
            }}>
                <UnderlineNav.Item aria-current={props.selectedTab === "clb" ? true : undefined} icon={ListOrderedIcon}
                    onSelect={() => {
                        props.onSelectedChanged("clb")
                    }}
                >Danh sách câu lạc bộ</UnderlineNav.Item>
                <UnderlineNav.Item aria-current={props.selectedTab === "ket-qua" ? true : undefined} icon={TrackedByClosedCompletedIcon}
                    onSelect={() => {
                        props.onSelectedChanged("ket-qua")
                    }}
                >Lịch sử đăng ký</UnderlineNav.Item>
            </UnderlineNav>
    );
};

export default MeetingNavigation;